import script from "./JaMonitorManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./JaMonitorManagement.vue?vue&type=script&setup=true&lang=js"

import "./JaMonitorManagement.vue?vue&type=style&index=0&id=3f8094ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8094ce"]])

export default __exports__